<zef-form
  [state]="state"
  (submit)="submit.emit(state)">

  <zui-http-routing-fields
    (removeLocation)="removeLocation.emit($event)"
    (removeBasicAuthUser)="removeBasicAuthUser.emit($event)"
    (addBasicAuthUser)="addBasicAuthUser.emit($event)"
    (domainSelected)="domainSelected.emit($event)"
    (domainBlacklisted)="domainBlacklisted.emit($event)"
    (resetAdvancedConfig)="resetAdvancedConfig.emit($event)"
    [domainsControl]="state?.controls.domains"
    [sslControl]="state?.controls.sslEnabled"
    [cdnControl]="state?.controls.cdnEnabled"
    [domainsBlacklist]="domainsBlacklist"
    [locationsControl]="state?.controls.locations"
    [portsWithServiceStackInfo]="portsWithServiceStackInfo"
    [mode]="mode"
    [translations]="httpRoutingFieldsTranslations"
  />

  <ng-content />

</zef-form>
